import { FC } from "react";
import ReleaseTable from "../ReleaseTable/ReleaseTable";
import { Release } from "models/release";

export type ModuleOverviewProps = {
    activeModule: string;
    releases: Release[];
    onReleaseSelect: (release: Release) => void;
    selectedRelease: Release | null;
};

const ModuleOverview: FC<ModuleOverviewProps> = ({
    activeModule,
    releases,
    onReleaseSelect,
    selectedRelease,
}) => {
    return (
        <>
            <div className="row">
                <div className="col">
                    <h2>
                        {releases.length
                            ? undefined
                            : "Er zijn geen releases gevonden!"}
                    </h2>
                </div>
            </div>
            {releases.length && (
                <ReleaseTable
                    releases={releases}
                    onReleaseSelect={onReleaseSelect}
                    selectedRelease={selectedRelease}
                />
            )}
            <div className="col-7 pb-4">
                <strong>Instructie: </strong>
                <br />
                <p
                    style={
                        activeModule === "Workflow"
                            ? { display: "unset" }
                            : { display: "none" }
                    }
                >
                    Voor de implementatie van <b>client side</b> activiteiten
                    zie informatie op{" "}
                    <a href="https://developers.geocortex.com/docs/workflow/sdk-web-overview#register-the-activity-pack">
                        deze pagina
                    </a>
                    .<br />
                    Voor de implementatie van <b>server side/mobile</b>{" "}
                    activiteiten zie informatie op{" "}
                    <a href="https://developers.geocortex.com/docs/workflow/sdk-server-overview/#deploying-geocortex-workflow-server-activities">
                        deze pagina
                    </a>
                    .
                </p>
                <p
                    style={
                        activeModule === "Mobile"
                            ? { display: "unset" }
                            : { display: "none" }
                    }
                >
                    De implementatie/distributie van de custom mobile GXM
                    applicatie hangt af van de device keuze (iOS, Android, UWP)
                    en de deployment strategie. Zie informatie op deze{" "}
                    <a href="https://docs.microsoft.com/en-us/xamarin/xamarin-forms/deploy-test/">
                        pagina
                    </a>
                    .
                </p>
                <p
                    style={
                        activeModule === "Web"
                            ? { display: "unset" }
                            : { display: "none" }
                    }
                >
                    Om een custom web component te installeren voer je de
                    onderstaande acties uit: <br />
                    1) Download de .zip file. <br />
                    2) Navigeer naar 'File - Upload App' in de web designer.
                    <br />
                    3) Volg de instructies om de .zip te uploaden.
                </p>
            </div>
        </>
    );
};

export default ModuleOverview;
